import axios from "axios";

export const privateHttp = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

export const publicHttp = axios.create({
  // baseURL: 'https://api.example.com',
});

privateHttp.interceptors.request.use(
  (config) => {
    console.log("config", config);
    // 쿠키에서 토큰을 가져오는 방법을 변경
    const token = getCookie("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 쿠키에서 값을 가져오는 유틸리티 함수
function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
}
// const checkTokenExpiry = () => {
//     const [cookies, setCookie, removeCookie] = useCookies(['token']);
//     const token = cookies.token;
//     if (token) {
//         const { exp } = JSON.parse(atob(token.split('.')[1]));
//         if (Date.now() >= exp * 1000) {
//             removeCookie('token'); // 토큰 만료 시 쿠키에서 삭제
//             logoutUser(); // 로그아웃 처리
//         }
//     }
// };
